import { render, staticRenderFns } from "./CreateAuthForm.vue?vue&type=template&id=0c022076&"
import script from "./CreateAuthForm.vue?vue&type=script&lang=js&"
export * from "./CreateAuthForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports